import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DoneIcon from "@mui/icons-material/Done";
import { Button } from "react-day-picker";
import { IconButton } from "@mui/material";
import { ChevronLeft, ArrowBack } from "@mui/icons-material";
import CW1 from "../Assets/images/CU-W1.png";
import CW2 from "../Assets/images/CU-W2.png";
import CW3 from "../Assets/images/CU-W3.png";
import CW4 from "../Assets/images/CU-W4.png";
import awlogo from "../Assets/images/Group 16808.png";

function CorpWelcomeScreen() {

    const WalkThroughSection = [
        {
            name: "W1",
            image: CW1,
            title: "Great Choice in Investing in Your Health!",
            text: "For every ₹1 invested in health today, save ₹9 tomorrow!",
        },
        {
            name: "W2",
            image: CW2,
            title: "We Offer:",
            text: "<ul><li>Cutting-edge AI-Powered diagnosis</li><li>Expert Ayurveda Guidance for Personalized Recommendations</li><li>Science-backed & data-driven health metrics </li></ul>",
        },
        {
            name: "W3",
            image: CW3,
            title: "You Benefit:",
            text: "<p>By having</p><ul><li>Less Stress, More Focus</li><li>Stronger Immunity, High Energy</li><li>Better Digestion & Sleep</li></ul>",
        },
        {
            name: "W4",
            image: CW4,
            title: "Good News - <span>Your <br/>Employer’s got your back</span>",
            text: "Your employer covers a part—you pay just a fraction for your wellness.",
        },
    ];

    const [index, setIndex] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    const goToNextSlide = () => {
        if (index >= WalkThroughSection.length - 1) {
            navigate("/CorpPackage", { state: { from: location?.state?.from } });
        } else {
            setIndex(index + 1);
        }
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => goToNextSlide(),
        onSwipedRight: () => setIndex((prev) => Math.max(prev - 1, 0)),
        preventScrollOnSwipe: true,
        trackMouse: true,
    });

    return (
        <div className="Onboarding-Screen flex flex-col h-full w-full " {...handlers}>

            <nav className='flex flex-row w-full p-2 justify-between' >
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBack />
                </IconButton>
                <div
                    className="skip-btn"
                    // style={{ justifySelf: "flex-end" }}
                    onClick={() => {
                        navigate("/CorpPackage", { state: { from: location?.state?.from } });
                    }}
                >
                    <p> Skip</p>
                </div>
            </nav>

            <div className="flex flex-col items-center justify-between w-full max-w-md flex-grow">

                <div
                    className={

                        "Onboarding-animation"
                    }
                >
                    <img src={WalkThroughSection[index]?.image} />
                </div>

                <div className="corpuser-Title-text-area text-center w-full">
                    <p dangerouslySetInnerHTML={{ __html: WalkThroughSection[index].title }} />
                </div>

                <div className="corpuser-text-area w-full text-center">
                    <p dangerouslySetInnerHTML={{ __html: WalkThroughSection[index].text }} />
                </div>

                <div className="flex flex justify-between items-center" style=
                    {{
                        width: "100%",

                    }}>

                    <div className="flex gap-2">
                        {WalkThroughSection.map((_, i) => (
                            <div
                                key={i}
                                onClick={() => setIndex(i)}
                                className={`h-3 w-3 rounded-full cursor-pointer transition-all ${i === index ? "bg-[#DA6E0B] w-8" : "bg-gray-300"
                                    }`}
                            />
                        ))}
                    </div>

                    {index === WalkThroughSection.length - 1 ? (
                        <Button
                            style={{

                                textTransform: 'none',
                                borderRadius: '0',
                                backgroundColor: '#DA6E0B',
                                color: 'white',
                                display: "block",
                                fontSize: "12px",
                                border: 'none',
                                boxSizing: 'border-box',
                                borderRadius: '5px',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '10px'
                            }}
                            onClick={goToNextSlide}
                        >
                            Let’s Do This!
                        </Button>
                    ) : (
                        <button
                            className="bg-[#DA6E0B] text-white p-2 rounded-full flex items-center justify-center justify-center"
                            onClick={goToNextSlide}
                        >
                            <ArrowForwardIcon fontSize="small" />
                        </button>
                    )}
                </div>
            </div>



        </div>
    );
}

export default CorpWelcomeScreen;
